<template>
  <b-modal id="agreement-modal" size="md" title="Agreement Summary" hide-footer>
    <template #modal-title>
      <div class="agreement-modal-title">
        <span class="title-label">
          Agreement Summary
        </span>
        <!-- <span class="title-meta">
          Latest distributor contract snapshot
        </span> -->
      </div>
    </template>
    <div v-if="!agreement" class="agreement-empty">
      <p class="empty-text">
        The vessel is not serviced under an agreement with a distributor. Payment is only possible via Stripe.
      </p>

      <b-button @click="$router.push('distributors')" size="sm" variant="info" block class="choose-button">
        Choose a distributor
      </b-button>
    </div>
    <div v-else class="agreement-card">
      <div class="agreement-header">
        <div>
          <div class="agreement-title">
            {{ agreement.name }}
          </div>
          <div class="agreement-subtitle">
            Agreement ID #{{ agreement.displayId }}
          </div>
        </div>
        <span :class="['status-chip', isExpired ? 'status-expired' : 'status-active']">
          {{ isExpired ? 'Expired' : 'Active' }}
        </span>
      </div>

      <div class="agreement-section">
        <div class="section-grid">
          <div class="section-field">
            <span class="field-label">Currency</span>
            <span class="field-value">{{ agreement.currency || '—' }}</span>
          </div>
          <div class="section-field">
            <span class="field-label">Valid till</span>
            <span
                class="field-value"
                :class="{ 'value-danger': isExpired }"
            >
              {{ formatDate(agreement.validTill) }}
            </span>
          </div>
        </div>
      </div>

      <div class="agreement-section">
        <div class="section-label">
          Available Services
        </div>
        <div class="service-list">
          <div class="service-item is-available">
            <span class="service-icon">
              <i class="fas fa-check-circle" />
            </span>
            <div class="service-copy">
              <span class="service-name">Primar ENC</span>
              <span class="service-meta">Valid till {{ formatDate(agreement.validTill) }}</span>
            </div>
          </div>
          <div class="service-item needs-action">
            <span class="service-icon">
              <i class="fas fa-check-circle" />
            </span>
            <div class="service-copy">
              <span class="service-name">NAVAREA</span>
              <span class="service-meta">
                <span class="service-meta">Demo valid till {{ formatDate(agreement.validTill) }}</span>
              </span>
            </div>
          </div>
          <div class="service-item is-missing">
            <span class="service-icon">
              <i class="fas fa-times-circle" />
            </span>
            <div class="service-copy">
              <span class="service-name">AIO</span>
              <span class="service-meta">
                <a href="#">request the service...</a>
              </span>
            </div>
          </div>
          <div class="service-item is-available">
            <span class="service-icon">
              <i class="fas fa-check-circle" />
            </span>
            <div class="service-copy">
              <span class="service-name">Monitoring</span>
              <span class="service-meta">Valid till {{ formatDate(agreement.validTill) }}</span>
            </div>
          </div>
          <div class="service-item is-available">
            <span class="service-icon">
              <i class="fas fa-check-circle" />
            </span>
            <div class="service-copy">
              <span class="service-name">Tides</span>
              <span class="service-meta">Valid till {{ formatDate(agreement.validTill) }}</span>
            </div>
          </div>
          <div class="service-item is-available">
            <span class="service-icon">
              <i class="fas fa-check-circle" />
            </span>
            <div class="service-copy">
              <span class="service-name">Weather</span>
              <span class="service-meta">Valid till {{ formatDate(agreement.validTill) }}</span>
            </div>
          </div>
          <div class="service-item is-available">
            <span class="service-icon">
              <i class="fas fa-check-circle" />
            </span>
            <div class="service-copy">
              <span class="service-name">Route planning</span>
              <span class="service-meta">Valid till {{ formatDate(agreement.validTill) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    agreement: {
      type: Object,
      default: null,
    },
  },
  computed: {
    // Проверка, истек ли срок действия договора
    isExpired() {
      if (!this.agreement || !this.agreement.validTill) return false
      return new Date(this.agreement.validTill) < new Date()
    },
  },
  methods: {
    // Форматирование даты в удобочитаемый формат
    formatDate(dateString) {
      if (!dateString) return 'N/A'
      return new Date(dateString).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    },
  },
}
</script>

<style scoped>
.agreement-empty {
  padding: 1.75rem 1.25rem;
  text-align: center;
  color: #4a5266;
}

.empty-text {
  margin-bottom: 1.25rem;
  font-size: 0.92rem;
}

.choose-button {
  font-weight: 600;
  letter-spacing: 0.01em;
}

.agreement-card {
  background: #ffffff;
  border: 1px solid #e5e8f0;
  border-radius: 16px;
  box-shadow: 0 12px 28px rgba(23, 30, 56, 0.14);
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 22px;
}

::v-deep .modal-header {
  background: linear-gradient(135deg, #f4f6ff 0%, #e6e9ff 100%);
  border-bottom: none;
  padding: 18px 22px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: inset 0 -1px 0 rgba(98, 111, 149, 0.12);
}

::v-deep .modal-header .close {
  color: #4b5fdd;
  opacity: 0.75;
  text-shadow: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

::v-deep .modal-header .close:hover {
  opacity: 1;
  transform: scale(1.05);
}

.agreement-modal-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif;
}

.title-label {
  color: #1f2940;
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.title-meta {
  color: #5b6480;
  font-size: 0.74rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

.agreement-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.agreement-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: #1f2940;
  letter-spacing: 0.01em;
}

.agreement-subtitle {
  color: #6a738c;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  margin-top: 4px;
}

.status-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  box-shadow: inset 0 0 0 1px rgba(98, 111, 149, 0.1);
}

.status-active {
  background: linear-gradient(135deg, #f1f7f4, #e3f5ea);
  color: #1f7a4d;
}

.status-expired {
  background: #ffe5ea;
  color: #a90021;
}

.agreement-section {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.section-label {
  text-transform: uppercase;
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  font-weight: 600;
  color: #6a738c;
}

.section-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 14px;
}

.section-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-label {
  color: #6a738c;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
}

.field-value {
  color: #2a3144;
  font-size: 0.88rem;
  font-weight: 500;
}

.field-value.value-danger {
  color: #a90021;
}

.service-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.service-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(229, 232, 240, 0.9);
  background: linear-gradient(135deg, #fbfcff, #f6f8ff);
  box-shadow: 0 6px 16px rgba(20, 29, 56, 0.06);
}

.service-item.is-available {
  border-color: rgba(58, 150, 104, 0.4);
}

.service-item.needs-action {
  border-color: rgba(75, 95, 221, 0.35);
}

.service-item.is-missing {
  border-color: rgba(214, 68, 95, 0.35);
}

.service-icon {
  font-size: 1rem;
  color: #4b5fdd;
  margin-top: 1px;
}

.service-item.is-available .service-icon {
  color: #2f9c68;
}

.service-item.is-missing .service-icon {
  color: #d6445f;
}

.service-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.service-name {
  color: #1f2940;
  font-size: 0.86rem;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.service-meta {
  color: #67708b;
  font-size: 0.8rem;
}

.service-meta a {
  color: #3a4256;
  border-bottom: 1px dashed rgba(37, 45, 64, 0.5);
  padding-bottom: 1px;
  transition: color 0.2s ease;
  text-decoration: none;
}

.service-meta a:hover {
  color: #161b28;
  text-decoration: none;
}

@media (max-width: 576px) {
  .agreement-card {
    padding: 16px;
  }

  .section-grid {
    grid-template-columns: 1fr;
  }
}
</style>
